import React from 'react';
import { Paginate } from '@nextiva/next-ui';
import TableDisplaySettings from "./TableDisplaySettings";

var DataTableSettings = function DataTableSettings(props) {
  var totalPages = props.totalPages,
      updateDisplayPreferences = props.updateDisplayPreferences,
      displayPreferences = props.displayPreferences;
  return React.createElement("div", {
    className: "nx-table-search"
  }, React.createElement("div", {
    className: "nx-table-search__new-entity"
  }, React.createElement("i", {
    className: "icon-custom-plus"
  })), React.createElement("div", {
    className: "nx-table__section-container"
  }, React.createElement(Paginate, {
    pageCount: totalPages
  }), React.createElement(TableDisplaySettings, {
    onClickAway: updateDisplayPreferences,
    options: displayPreferences
  })));
};

export default DataTableSettings;